
const ScriptureBanner = () => {
  return (
    <section className="bg-[#F5E6D3] py-10">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <p className="text-xl md:text-2xl font-serif italic text-[#1B3A52] mb-3 leading-relaxed">
          "For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you, plans to give you hope and a future."
        </p>
        <p className="text-xs text-gray-600">
          — Jeremiah 29:11
        </p>
      </div>
    </section>
  );
};

export default ScriptureBanner;
